import { render, staticRenderFns } from "./ppt-title.vue?vue&type=template&id=895c0a4a&scoped=true&"
import script from "./ppt-title.vue?vue&type=script&lang=js&"
export * from "./ppt-title.vue?vue&type=script&lang=js&"
import style0 from "./ppt-title.vue?vue&type=style&index=0&id=895c0a4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895c0a4a",
  null
  
)

export default component.exports